import { Loader, styled, Table } from "@monolith-forensics/monolith-ui";
import { useRelayInfo } from "../../../hooks";
import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import RelayAPI from "../../../../../../api/RelayAPI";
import { useNavigate } from "react-router-dom";
import { InviteUserModal } from "../Modals";
import { RelayTenant } from "@/Features";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  overflow-y: auto;

  .user-name {
    font-weight: 500;
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const RelayUsers: React.FC = () => {
  const { relayInfo } = useRelayInfo();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery({
    queryKey: ["relay:users", { tenant_uuid: relayInfo?.tenant_uuid }],
    queryFn: () => RelayAPI.getUsers({ tenant_uuid: relayInfo?.tenant_uuid }),
    select: (data) => {
      return (
        data?.data?.map((user: any) => {
          // get tenant data
          const thisTenant = user.tenants.find(
            (tenant: RelayTenant) =>
              tenant.tenant_uuid === relayInfo?.tenant_uuid
          );

          return {
            ...user,
            is_admin: thisTenant.is_admin,
            is_active: thisTenant.active,
            is_deleted: thisTenant.is_deleted,
          };
        }) || []
      );
    },
    enabled: !!relayInfo,
  });

  if (isLoading || !relayInfo) return <Loader />;

  let users = data || [];

  const onInviteUser = (res: any) => {
    if (res.success && res.user) {
      queryClient.refetchQueries({
        queryKey: ["relay:users", { tenant_uuid: relayInfo.tenant_uuid }],
      });
    }
  };

  return (
    <StyledContainer>
      <InviteUserModal
        show={open}
        onClose={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        onSubmit={onInviteUser}
      />
      <Table
        data={users ? users : []}
        keyField="user_id"
        columnProps={[
          {
            dataField: "full_name",
            caption: "Name",
            render: ({ rowData }) => {
              return (
                <div
                  className="user-name"
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => navigate(`${rowData.user_id}`)}
                >
                  <div>{rowData?.full_name}</div>
                </div>
              );
            },
          },
          {
            dataField: "email",
            caption: "Email",
          },
          {
            dataField: "org",
            caption: "Organization",
          },
          {
            dataField: "is_admin",
            caption: "Relay Admin",
            render: ({ rowData }) => (rowData.is_admin ? "Yes" : "No"),
          },
        ]}
        virtualized={true}
        tableMenuOptions={{
          enabled: true,
          tableCountOptions: {
            recordsTotalEnabled: true,
          },
          exportOptions: {
            enabled: true,
          },
          searchOptions: {
            enabled: true,
            placeholder: "Search Users",
          },
          addButtonOptions: {
            enabled: true,
            label: "Invite User",
            onClick: () => setOpen(true),
          },
        }}
      ></Table>
    </StyledContainer>
  );
};
